'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Search": "Polaris-TopBar-Search",
  "SearchContent": "Polaris-TopBar-Search__SearchContent",
  "visible": "Polaris-TopBar-Search--visible",
  "Results": "Polaris-TopBar-Search__Results"
};

exports.default = styles;
